// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import { PropTypes } from 'prop-types';
import { configureInternalNavigationFromCMSUrl, processPath } from '../../../../../utils';
import Anchor from '../../Anchor';
import withStyles from '../../../hoc/withStyles';
import styles from '../BodyCopy.style';

const renderComponent = (compProps) => {
  const { Component, className, dataLocator, children, customStyle, ...others } = compProps;
  return (
    <Component className={className} data-locator={dataLocator} style={customStyle} {...others}>
      {children}
    </Component>
  );
};

const BodyCopy = (props) => {
  const {
    children,
    className,
    fontFamily,
    component: Component,
    fontSize,
    fontWeight,
    lineHeight,
    letterSpacing,
    textAlign,
    color,
    dataLocator,
    link,
    customStyle,
    trackNavigation,
    isShowNavAnimation,
    useStyle,
    buttonVariation,
    anchorVariation,
    fontSizeVariation,
    noCurveMobile,
    isOpen,
    removeL1PanelTimeOutItem,
    overrideStyle,
    isContainerModuleText,
    ...others
  } = props;

  const compProps = {
    Component,
    className,
    dataLocator,
    children,
    customStyle,
    ...others,
  };
  if (!link) {
    return renderComponent(compProps);
  }

  const { url: ctaUrl, target, title, actualUrl, className: ctaClassName } = link;

  let to = actualUrl;
  if (!actualUrl) {
    to = configureInternalNavigationFromCMSUrl(ctaUrl);
  }

  return (
    <Anchor
      className={ctaClassName}
      to={processPath(to, 'to')}
      asPath={processPath(ctaUrl, 'path')}
      target={target}
      title={title}
      dataLocator={`${dataLocator}-link`}
    >
      {renderComponent(compProps)}
    </Anchor>
  );
};

BodyCopy.defaultProps = {
  component: 'p',
  className: null,
  children: null,
  fontFamily: 'primary',
  fontSize: 12,
  fontWeight: 'regular',
  lineHeight: 'normal',
  letterSpacing: 'normal',
  textAlign: 'left',
  color: 'text.primary',
  link: null,
  customStyle: {},
};

BodyCopy.propTypes = {
  component: PropTypes.elementType,
  className: PropTypes.string,
  children: PropTypes.node,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.any,
  fontWeight: PropTypes.string,
  lineHeight: PropTypes.string,
  letterSpacing: PropTypes.string,
  textAlign: PropTypes.string,
  color: PropTypes.string,
  dataLocator: PropTypes.string,
  link: PropTypes.shape({
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    target: PropTypes.string,
    text: PropTypes.string,
  }),
  customStyle: PropTypes.shape({}),
};

const StyledBodyCopy = withStyles(BodyCopy, styles);
StyledBodyCopy.defaultProps = BodyCopy.defaultProps;

export { BodyCopy as BodyCopyVanilla };
export default StyledBodyCopy;
